export class Resultado {
    public tipoResultado: string;
    public objetoResultado: any;
    public codigoMensaje: string;
    public mensaje: string;
}

 